import axios from "axios";
import {getConfig} from '../helpers/config';

export class LibreriaService {

	baseAPIUrl = `${getConfig()?.url}librerie`;

	getById = async (id) => {
		return await axios.get(`${this.baseAPIUrl}/${id}`)
											.then(res => res.data);
	}

	getAll = async () => {
		return await axios.get(`${this.baseAPIUrl}/`)
											.then(res => res.data);
	}

	getAllDt = async (data) => {
		return await axios.post(`${this.baseAPIUrl}/dt`, data)
											.then(res => res.data);
	}

	create = async (data) => {
		return await axios.post(`${this.baseAPIUrl}/`, data)
											.then(res => res.data);
	}

	update = async (data) => {
		return await axios.put(`${this.baseAPIUrl}/`, data)
											.then(res => res.data);
	}

	delete = async (id) => {
		return await axios.delete(`${this.baseAPIUrl}/${id}`)
											.then(res => res.data);
	}

	valida = async (libreriaId, enteId) => {
		return await axios.put(`${this.baseAPIUrl}/${libreriaId}/${enteId}/valida`)
											.then(res => res.data);
	}

	svalida = async (libreriaId, enteId) => {
		return await axios.put(`${this.baseAPIUrl}/${libreriaId}/${enteId}/svalida`)
											.then(res => res.data);
	}

	associate = async (libreriaId, enteId) => {
		return await axios.put(`${this.baseAPIUrl}/${libreriaId}/${enteId}`)
											.then(res => res.data);
	}

	remove = async (libreriaId, enteId) => {
		return await axios.delete(`${this.baseAPIUrl}/${libreriaId}/${enteId}`)
											.then(res => res.data);
	}
}
